var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.439462 6.91138C-0.146324 7.49717 -0.146324 8.44691 0.439462 9.0327C0.543436 9.13667 0.658876 9.22219 0.781712 9.28926L7.05311 15.5607C7.6389 16.1464 8.58865 16.1464 9.17443 15.5607C9.76022 14.9749 9.76022 14.0251 9.17443 13.4393L3.66429 7.92919L8.92474 2.66874C9.51053 2.08295 9.51053 1.13321 8.92474 0.547419C8.33896 -0.0383681 7.38921 -0.0383681 6.80342 0.547419L0.439462 6.91138Z",
    fill: "#414149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.5de34a5c541c0d8910489f4969c716ff.svg";
export { ForwardRef as ReactComponent };